<template>
  <div>
    <ViewTemplateWithTable :panel="panel" :templateList="templateList" :actions="actions" :filters="filters"
                           :propsParam="propsParam">
      <div slot="content-buttons">
        <Button _key="btnProductCreate" title="Locação" classIcon="fas fa-plus-circle" type="primary" size="small"
                eventName="productCreate" :clicked="create"/>
      </div>
      <div slot="content-between-search-table">
        <div class="div-archived">
          <ButtonToggle titleActive="Arquivada" titleInactive="Arquivada" colorActive="#453DB4"
                        classIconActive="fa-regular fa-check-double" classIconInactive="fa-solid fa-box-archive"
                        colorInactive="#F0F0F0" v-model="propsParam.archived"/>
        </div>
      </div>
    </ViewTemplateWithTable>

    <PrintPreview v-if="printRent" module="Rental" :rentId="id" :canModifyDocument="true" :onHideModal="closeModal">
      <Select title="Período de Locação (opcional)" v-if="totalRecordsPeriod > 1" field="type" :required="false"
              :propsParams="{ any: id }" :showNewRegister="false" url="/api/v1/rental/period-rent/select-all"
              v-model="periodRent">
      </Select>
    </PrintPreview>
  </div>
</template>

<script>

import ViewTemplateWithTable from "@nixweb/nixloc-ui/src/component/template/ViewTemplateWithTable.vue";
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import ButtonToggle from "@nixweb/nixloc-ui/src/component/forms/ButtonToggle";
import Select from "@nixweb/nixloc-ui/src/component/forms/Select";

import PrintPreview from '../../../components/modules/adm/document/PrintPreview.vue'

import {mapActions, mapGetters, mapMutations} from "vuex";

export default {
  name: "RentalListView",
  components: {
    ViewTemplateWithTable,
    Button,
    ButtonToggle,
    Select,
    PrintPreview,
  },
  data() {
    return {
      id: "",
      printRent: false,
      totalRecordsPeriod: 0,
      urlGetApi: "/api/v1/rental/period-rent/get-all",
      panel: {
        module: "Locação",
        title: "Locação",
        showFilter: true,
        showSearch: true,
        showButtons: true,
      },
      templateList: {
        urlGetApi: "/api/v1/rental/rent/get-all",
        urlDeleteAllApi: "/api/v1/rental/rent/delete",
        showChecks: true,
        headerTable: [
          {
            title: "",
            field: "archivedHtml",
            type: "html",
            classCssTitle: "text-center",
            classCssBody: "text-center",
            styleBody: "width: 20px;",
          },
          {
            title: "",
            field: "step",
            type: "html",
            classCssTitle: "text-center",
            classCssBody: "text-center",
            styleBody: "width: 20px;",
          },
          {
            title: "Número/Data",
            field: "numberAndDate",
            type: "text",
            iconSearch: true,
            styleBody: "width: 140px;",
          },
          {
            field: "fullName",
            fieldSecond: "identification",
            title: "Nome",
            type: "link",
            routeName: "rentUpdate",
            styleBody: "max-width: 250px;white-space: nowrap; overflow: hidden;text-overflow: ellipsis;",
            iconSearch: true,
          },
          {
            field: "consultant",
            title: "Consultor",
            type: "text",
            styleBody: "max-width: 130px;white-space: nowrap; overflow: hidden;text-overflow: ellipsis;",
            classCssTitle: "text-center",
            classCssBody: "text-center",
          },
          {
            title: "Período(Início/Fim)",
            field: "tags",
            type: "html",
            classCssTitle: "text-center",
            classCssBody: "text-center",
            styleBody: "max-width: 300px;",
          },
          {
            field: "statusRentalName",
            title: "Status",
            type: "class",
            fieldComparison: "statusRentalName",
            classCssTitle: "text-center",
            classCssBody: [
              {
                classCss: "text-center badge badge-info",
                fieldComparison: "Orçamento",
              },
              {
                classCss: "text-center badge badge-success",
                fieldComparison: "Aprovada",
              },
              {
                classCss: "text-center badge badge-danger",
                fieldComparison: "Reprovada",
              },
              {
                classCss: "text-center badge badge-primary",
                fieldComparison: "Finalizada",
              },
            ],
          },
          {
            field: "statusInvoiceName",
            title: "Faturado",
            type: "class",
            fieldComparison: "statusInvoiceName",
            classCssTitle: "text-center",
            classCssBody: [
              {
                classCss: "text-center badge badge-info",
                fieldComparison: "Não Fatura",
              },
              {
                classCss: "text-center badge badge-success",
                fieldComparison: "Faturado",
              },
              {
                classCss: "text-center badge badge-warning",
                fieldComparison: "Não Faturado",
              },
              {
                classCss: "text-center badge badge-info",
                fieldComparison: "Parcial",
              },
            ],
          },
          {
            title: "Valor",
            field: "value",
            classCssTitle: "text-center",
            classCssBody: "text-center",
            styleBody: "width: 150px;",
            type: "currency",
          },
          {
            type: "button",
            typeButton: "default",
            button: {
              classIcon: "fa-light fa-share-nodes",
              type: "info",
              size: "small",
              eventName: "printRent",
            },
          },
        ],
      },
      actions: [
        {
          type: "delete",
          title: "Remover",
          description: "Remover",
          url: "/api/v1/rental/rent/delete",
          method: "delete",
        },
        {
          type: "options",
          title: "Status",
          url: "/api/v1/rental/rent/change-status",
          classIcon: "fa-solid fa-option",
          description: "Mudança de Status",
          method: "put",
          options: [
            {text: "Orçamento", value: "progress",},
            {text: "Aprovada", value: "accept"},
            {text: "Reprovada", value: "reject"},
          ],
        },
      ],
      filters: [
        {
          type: "multiOptions",
          title: "Consultor",
          field: "Consultant",
          url: "/api/v1/human-resources/collaborator/select-all",
          propsParams: {isConsultant: true},
          value: "",
        },
        {
          type: "date",
          title: "Data Cadastro",
          field: "RegisteredDate",
          value: "",
        },
        {
          type: "date",
          title: "Data Efetivação",
          field: "DateAccepted",
          value: "",
        },
        {
          type: "options",
          title: "Faturamento",
          field: "StatusInvoiceName",
          options: [
            {text: "Faturado", value: "Faturado"},
            {text: "Parcial", value: "Parcial"},
            {text: "Não Faturado", value: "Não Faturado"},
            {text: "Não Fatura", value: "Não Fatura"},
          ],
          value: [],
        },
        {
          type: "dateRange",
          title: "Período de Locação",
          field: "PeriodRent",
          value: "",
        },
        {
          type: "options",
          title: "Status",
          field: "StatusRentalName",
          options: [
            {text: "Orçamento", value: "Orçamento"},
            {text: "Aprovada", value: "Aprovada"},
            {text: "Reprovada", value: "Reprovada"},
          ],
          value: [],
        },
        {
          type: "multiOptions",
          title: "Tipo de Locação",
          field: "TypeRentName",
          url: "/api/v1/rental/type-rent/select-all",
          value: "",
        },
        {
          type: "decimal",
          title: "Valor",
          field: "TotalGeneral",
          valueStart: 0,
          valueEnd: 0,
        },
      ],
      propsParam: {
        archived: false,
      },
    };
  },
  mounted() {
    var filterStorage = this.get_FilterStorage(this.$route.name);
    if (filterStorage) {
      this.propsParam = filterStorage.propsParam;
    }
  },
  computed: {
    ...mapGetters("generic", ["showModal", "event", "get_FilterStorage"]),
  },
  methods: {
    ...mapMutations("generic", ["openModal", "hideModal", "removeLoading", "executedSearch", "_addFilterStorage"]),
    ...mapActions("generic", ["getApi", "deleteAllApi"]),
    create() {
      let self = this;
      setTimeout(function () {
        self.$router.push({
          name: "rentCreate",
          params: {type: 1},
        });
        self.removeLoading(["btnProductCreate"]);
      }, 200);

    },
    remove() {
      let params = {
        url: this.templateList.urlDeleteAllApi,
        selected: [this.id],
      };

      this.deleteAllApi(params).then((response) => {
        if (response.success) {
          this.hideModal("removeRent");
        }
        this.removeLoading(["confirm"]);
      });
    },
    closeModal() {
      this.printRent = false;
    },
    getTotalPeriodRent() {
      let params = {
        url: this.urlGetApi,
        obj: {
          rentId: this.id,
          periodRentId: "null",
          noPaginated: true,
        },
      };
      this.getApi(params).then((response) => {
        this.totalRecordsPeriod = response.content.totalRecords;
      });
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name == "removeRent") {
          this.id = event.data.id;
          this.openModal("removeRent");
        }

        if (event.name == "printRent") {
          this.id = event.data.id;
          this.getTotalPeriodRent();
          this.printRent = true;
        }

        if (event.name == "totalRecordsPeriod")
          this.totalRecordsPeriod = event.data.totalRecords;
      },
      deep: true,
    },
    propsParam: {
      handler() {
        this.executedSearch();
        this._addFilterStorage({routeName: this.$route.name, propsParam: this.propsParam});
      },
      deep: true,
    },
  },
};
</script>

<style>
.badge-default {
  background-color: #eeeeee;
  font-size: 13px !important;
  border-radius: 50px !important;
}

.div-status {
  margin-left: 35px;
}

.div-archived {
  margin-bottom: 10px;
  margin-left: 5px;
  width: 125px;
}

.rent-progress {
  color: #577696;
  border: 1px solid #bee2f8 !important;
  background-color: #F2F9FE;
}

.fa-thumbs-up {
  color: #15A34A;
}

.fa-thumbs-down {
  color: #DC2626;
}

.rent-accepted {
  background: #F5FEFA;
  border: 1px solid #a7f3d0 !important;
  color: #065f46;
}

.rent-rejected {
  background: #FFF8F8;
  border: 1px solid #fecaca !important;
  color: #b91c1c;

}

.rent-icon-close {
  color: red;
}
</style>